export default __webpack_public_path__ + "static/media/nft-cover.50993314.png";